import React from "react";

interface HighlightedTextProps {
  text: string;
  highlight: string;
}

const HighlightedText: React.FC<HighlightedTextProps> = ({
  text,
  highlight,
}) => {
  const highlightedContent = React.useMemo(() => {
    if (!highlight.trim()) {
      return [text];
    }

    const escapedHighlight = highlight.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const regex = new RegExp(`(${escapedHighlight})`, "gi");

    const parts = text.split(regex);

    return parts.map((part, index) =>
      part.toLowerCase() === highlight.toLowerCase() ? (
        <mark key={index}>{part}</mark>
      ) : (
        part
      )
    );
  }, [text, highlight]);

  return <>{highlightedContent}</>;
};

export default HighlightedText;
